module.exports = __webpack_public_path__ + "img/IMG_9347.ff49aed7.jpg";